import {
  HTTP
} from '@/http';
import {
  getNewsFromInvesting
} from '@/services/NewsService';
import {
  getLatestPosts
} from '@/services/BlogService';
import AccountService from '@/services/AccountService';

let accountService = new AccountService();

export default class DashboardService {

  get() {
    return HTTP.get(`dashboard`);
  }

  getNews() {
    return getNewsFromInvesting();
  }

  getBlog() {
    return getLatestPosts();
  }

  getMt4Accounts() {
    return accountService.getMT4Accounts();
  }
}



// WEBPACK FOOTER //
// ./src/services/DashboardService.js